import React, { useEffect, useState } from "react";
import styled from 'styled-components'
import { CurrencyState } from "../Context";
import axios from 'axios'
import { Link } from "react-router-dom";
import { LinearProgress } from "@mui/material";



function Portfolio() {

    document.title = "Portfolio | Lehumo";

    const { currency, symbol, flag, cashWalletConverted } = CurrencyState();

    const [data, setData] = useState(null)

    const url = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&per_page=10&page=1&sparkline=false`;

    useEffect(() => {
        axios.get(url).then((response) => {
            setData(response.data)
        }).catch((error) => {
            console.log(error)
        });

    }, [currency]);


    if (!data) return <LinearProgress style={{ backgroundColor: "var(--primary)" }} />

    //Calculate BTC Holdings
    const BTCPrice = data[0].current_price;
    const BTCHoldings = 2.6932234;
    const UserHoldingBTC = BTCHoldings * BTCPrice;

    //Calculate ETH Holdings
    const ETHPrice = data[1].current_price;
    const ETHHoldings = 15.2423445676;
    const UserHoldingETH = ETHHoldings * ETHPrice;

    //Calculate BNB Holdings
    const BNBPrice = data[3].current_price;
    const BNBHoldings = 28.05224657;
    const UserHoldingBNB = BNBHoldings * BNBPrice;

    //Calculate XRP Holdings
    const XRPPrice = data[5].current_price;
    const XRPHoldings = 11582.78566789;
    const UserHoldingXRP = XRPHoldings * XRPPrice;

    //Calculate Total Digital
    const TotalDigitalAssets = UserHoldingBTC + UserHoldingETH + UserHoldingBNB + UserHoldingXRP;


    //Calculate Total Assets Value
    const TotalWalletValue = cashWalletConverted + TotalDigitalAssets;


    return (
        <>
            <Container>

                <Hero>
                    <h1>{symbol} {TotalWalletValue.toFixed(2)}</h1>
                    <p>Account Value (Cash + Assets)</p>
                </Hero>

                <AssetsBox>

                    <h1>Cash</h1>

                    <Section>
                        <FiatAccount>
                            <img src={flag} alt="" /> <h2>{symbol} {cashWalletConverted.toFixed(2)}</h2>
                        </FiatAccount>
                        <ButtonGroup>
                            <Link to="/AddFunds"><button><i className="fa-solid fa-plus"></i> Add Funds</button></Link> <Link to="/WithdrawFunds"><button><i className="fa-solid fa-bank"></i> Withdraw</button></Link>
                        </ButtonGroup>
                    </Section>

                    <h1>Assets</h1>

                    <Section>
                        <AssetsValue>
                            <h2>{symbol} {TotalDigitalAssets.toFixed(2)}</h2>
                        </AssetsValue>
                    </Section>

                    <DigitalAssets>

                        <CryptoCurrencies>
                            <img src={data[0].image} alt="" /><br />
                            <h2>
                                {data[0].symbol}: {BTCHoldings.toFixed(4)}<br />
                                <span>{symbol} {UserHoldingBTC.toFixed(2)}</span>
                            </h2>
                            <Link to={`/Buy/${data[0].id}`}><button className="buy-btn">Buy</button></Link> <Link to={`/Sell/${data[0].id}`}><button className="sell-btn">Sell</button></Link>
                        </CryptoCurrencies>

                        <CryptoCurrencies>
                            <img src={data[1].image} alt="" />
                            <h2>
                                {data[1].symbol}: {ETHHoldings.toFixed(4)} <br />
                                <span>{symbol} {UserHoldingETH.toFixed(2)}</span>
                            </h2>
                            <Link to={`/Buy/${data[1].id}`}><button className="buy-btn">Buy</button></Link> <Link to={`/Sell/${data[1].id}`}><button className="sell-btn">Sell</button></Link>
                        </CryptoCurrencies>

                        <CryptoCurrencies>
                            <img src={data[3].image} alt="" />
                            <h2>
                                {data[3].symbol}: {BNBHoldings.toFixed(4)}<br />
                                <span>{symbol} {UserHoldingBNB.toFixed(2)}</span>
                            </h2>
                            <Link to={`/Buy/${data[3].id}`}><button className="buy-btn">Buy</button></Link> <Link to={`/Sell/${data[3].id}`}><button className="sell-btn">Sell</button></Link>
                        </CryptoCurrencies>

                        <CryptoCurrencies>
                            <img src={data[5].image} alt="" />
                            <h2>
                                {data[5].symbol}: {XRPHoldings.toFixed(4)}<br />
                                <span>{symbol} {UserHoldingXRP.toFixed(2)}</span>
                            </h2>
                            <Link to={`/Buy/${data[5].id}`}><button className="buy-btn">Buy</button></Link> <Link to={`/Sell/${data[5].id}`}><button className="sell-btn">Sell</button></Link>
                        </CryptoCurrencies>

                    </DigitalAssets><br /><br />

                </AssetsBox>

            </Container >

        </>
    )
}

export default Portfolio

const Container = styled.div`
    margin-bottom: 20px;

`

const Hero = styled.div`

    height: 25vh;
    align-items: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0 auto;
    margin-top: 70px;
    background: var(--primary);
    border-bottom-left-radius: 30%;
    border-bottom-right-radius: 30%;


    h1 {
        text-transform: uppercase;
        font-size: 48px;
        font-weight: 600;
        color: #fff;
        text-align: center;
    }

    p {
        color: #fff;
        font-size: 13px;
        text-transform: uppercase;
    }

    @media (max-width: 768px) {
        height: 20vh;
        margin-bottom: 10px;

        h1 {
            font-size: 36px;
            padding: 30px 0 10px 0;
        }
    }

`

const AssetsBox = styled.div`

    background-color: #fff;
    width: 80%;
    height: auto;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;

    h1 {
        padding: 20px 0;
        font-size: 42px;
        text-transform: uppercase;
        color: #333;
    }


    @media (max-width: 768px) {
        width: 95%;
        margin-top: 0px;

    }

`

const Section = styled.div`
    width: 80%;
    height: auto;
    background-color: var(--background);
    margin: 0 auto;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    @media (max-width: 768px) {
        width: 90%;
        border-radius: 10px;
        height: 200px;
    }

`

const FiatAccount = styled.div`
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: flex;

    h2 {
        color: #333;
        font-size: 36px;
    }

    img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-top: 20px;
    }


    @media (max-width: 768px) {

        img {
            width: 40px;
            height: 40px;
            margin-top: 20px;
        }

        h2 {
            font-size: 32px;
            margin-bottom: 25px;
        }
    }
`

const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;


    button {
        width: 130px;
        height: 50px;
        margin-top: 5px;
        margin-right: 5px;
        text-transform: uppercase;
        background-color: var(--primary);
        border: none;
        color: #fff;
        box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.2), inset 2px 2px 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        font-weight: 700;
        font-size: 12px;

        :hover {
            background-color: transparent;
            border: 2px solid var(--primary);
            color: var(--primary);
            transition: 0.2s ease-in;
        }
    }

    @media (max-width: 768px) {
        width: 90%;
        height: 250px;
        flex-wrap: wrap;
         margin-bottom: 20px;
         margin-top: 10px;

        button {
            border-radius: 10px;
        }
    }

`

const DigitalAssets = styled.div`
    width: 80%;
    align-items: center;
    margin: 0 auto;
    justify-content: space-evenly;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(2, minmax(0,1fr));
    margin-top: 10px;

    @media (max-width: 768px) {
        width: 90%;
        justify-content: center;
        display: flex;
        flex-direction: column;
    }
`

const AssetsValue = styled.div`
    h2 {
        font-size: 40px;
        margin: 30px auto;
    }
`

const CryptoCurrencies = styled.div`
    height: 100%;
    background-color: var(--background);
    justify-content: center;
    align-items: center;
    border-radius: 5px;
 
    h2 {
        color: #333;
        font-size: 14px;
        text-align: center;
        line-height: 1.5;
        font-weight: 400;
        text-transform: uppercase;
        margin-bottom: 10px;

        span {
            font-weight: 600;
            font-size: 13px;
        }
    }

    img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-top: 10px;
    }

    button {
        width: 100px;
        height: 40px;
        border-radius: 20px;
        font-weight: 700;
        border: 2px solid var(--primary);
        text-transform: uppercase;
        font-size: 11px;
        margin-bottom: 15px;
    }

    .buy-btn {
        border: none;
        background-color: var(--primary);
        color: #fff;
        box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.1), inset 2px 2px 5px rgba(0, 0, 0, 0.1);

        :hover {
            background-color: transparent;
            color: var(--primary);
            border: 2px solid var(--primary);
            transition: 0.3s ease-in;
        }
    }

    .sell-btn {
        background-color: transparent;
        color: var(--sell-btn);
        box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.1), inset 2px 2px 5px rgba(0, 0, 0, 0.1);
        border: 2px solid var(--sell-btn);

        :hover {
            background-color: var(--sell-btn);
            color: #fff;
            transition: 0.3s ease-in;
        }
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(1, minmax(0,1fr));
        width: 100%;
        
        h2 {
            font-weight: 400;
            font-size: 12px;
        }

        img {
            width: 40px;
            height: 40px;
            margin-left: 10px;
            margin-bottom: 10px;
        }

        button {
            width: 80px;
            height: 35px;
            margin-bottom: 20px;
        }

        .sell-btn {
            margin-left: 5px;
        }
    }

`
